module.exports = __webpack_public_path__ + "img/sec-18-db.5b523b33.svg";